import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GlobalApplicationSettings {
  public handleHttpExceptions = true;
  public maintenanceMode = false;
}
